import { IHashMap, IModifiedType } from "../sync/sync.types";
import { NODEVICEID } from "./DutyStatusLog";
import idSerializer from "geotab-uuid";

export interface ITripAnnotation extends IHashMap<ITripAnnotation> {
    dateTime?: string;
    device: IIdEntity;
    text: string;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;
}

export default class TripAnnotation implements ITripAnnotation {
    id: string;
    dateTime?: string | undefined;
    device: IIdEntity;
    text: string;

    modified?: IModifiedType;
    previousState?: ITripAnnotation;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    _syncCounter?: number;

    constructor(obj: DeepReadonly<ITripAnnotation>) {
        this.id = obj.id || idSerializer.get();
        this.dateTime = obj.dateTime;
        this.device = obj.device && obj.device.id ? obj.device : { id: NODEVICEID };
        this.text = obj.text;

        this.modified = obj.modified;
        this.previousState = obj.previousState;
        this._syncCounter = obj._syncCounter || 5;
    }
}